import { call, put, takeLatest } from "redux-saga/effects";
import { 
  ACCEPT_REJECT_RAW_MATERIALS_OR_PRODUCTION_STATUS, 
  CANCEL_PO, CREATE_PO, 
  DELETE_RAW_MATERIALS_OR_PRODUCTION_STATUS, 
  DOWNLOAD_PO_TEMPLATE, GET_ALL_PO, 
  GET_PART_DETAILS, 
  GET_PO_DATA_BY_ID, 
  GET_PO_DROPDOWN_LISTS, 
  GET_PO_HISTORY, 
  GET_PO_LIST, 
  GET_PO_STATUS_COUNT, 
  GET_RAW_MATERIALS_OR_PRODUCTION_STATUS, 
  SAVE_ALL_PO, 
  SAVE_PART_DETAILS, 
  SAVE_PO_DROPDOWN_LISTS, 
  SAVE_RAW_MATERIALS_OR_PRODUCTION_STATUS, 
  TOAST_ERROR, 
  TOAST_SUCCESS, 
  UPDATE_PO, 
  UPDATE_RAW_MATERIALS_OR_PRODUCTION_STATUS, 
  UPLOAD_PO_DETAILS 
} from "Constants/actionConstants";
import { 
  ACCET_REJECT_RAW_MATERIALS_OR_PRODUCTION_STATUS_URL, 
  CANCEL_PO_URL, 
  CREATE_PO_URL, 
  DELETE_RAW_MATERIALS_OR_PRODUCTION_STATUS_URL, 
  DOWNLOAD_PO_TEMPLATE_URL, 
  FETCH_ALL_PO_URL, 
  GET_PART_DETAILS_URL, 
  GET_PO_DATA_BY_ID_URL, 
  GET_PO_DROPDOWN_LISTS_URL, 
  GET_PO_HISTORY_URL, 
  GET_PO_LIST_URL, 
  GET_PO_STATUS_COUNT_URL, 
  GET_RAW_MATERIALS_OR_PRODUCTION_STATUS_URL, 
  SAVE_RAW_MATERIALS_OR_PRODUCTION_STATUS_URL, 
  UPDATE_PO_URL, 
  UPDATE_RAW_MATERIALS_OR_PRODUCTION_STATUS_URL, 
  UPLOAD_PO_URL 
} from "Utils/api";
import axiosT1 from "Utils/axios";
import { downloadUrl } from "Utils/index";
import { getPresignedUrl } from "./common";


export function* getAllPO(action) {
    try {
        const resData = yield call(
          axiosT1.get,
          FETCH_ALL_PO_URL,
          {
            params: action.params,
          }
        );
        // if(resData.data && resData.data.data.list.length > 0) {
        //   const params = {
        //     poId: resData.data.data.list[0]['po_id'],
        //   }
        //   if([3, 5].includes(action.activeStatusTab) && action.subTab) {
        //       params['type'] = action.subTab
        //   }
        //   yield put({
        //     type: GET_PART_DETAILS,
        //     params
        //   })
        // } else {
          yield put({
            type: SAVE_PART_DETAILS,
            payload: []
          });
        // }
        yield put({
          type: SAVE_ALL_PO,
          payload: {
            data: resData.data && resData.data.data.list || [],
            totalCount: resData.data.data.total_count || '',
            poStatusCount: resData.data.data.po_status || {}
          },
        });
        if(action.onSuccess) {
          action.onSuccess(resData.data && resData.data.data.list || []);
        }
      } catch (e) {
        console.log("e:", e);
      }
}

export function* createPO(action) {
    try {
        const resData = yield call(axiosT1.post, CREATE_PO_URL, action.data);
        if(action.onSuccess) {
            action.onSuccess();
        }
        yield put({
            type: TOAST_SUCCESS,
            message: (resData.data || {}).message
        });
    } catch(e) {
        console.log("e:", e);   
        if(e.response && e.response.data) {
          yield put({
            type: TOAST_ERROR,
            message: (e.response.data || {}).message
          });
        }
    }
}

export function* getPODropDownLists(action) {
  try {
      const resData = yield call(axiosT1.get, GET_PO_DROPDOWN_LISTS_URL);
      yield put({
          type: SAVE_PO_DROPDOWN_LISTS,
          payload: resData.data && resData.data.data || {}
      });
  } catch(e) {
      console.log("e:", e);
  }
}

export function* getPartDetails(action) {
  try {
    const resData = yield call(axiosT1.get, GET_PART_DETAILS_URL, { params: action.params });
    // yield put({
    //     type: SAVE_PART_DETAILS,
    //     payload: resData.data && resData.data.data && resData.data.data || []
    // });
    if(action.onSuccess) {
      action.onSuccess(resData.data && resData.data.data || {})
    }
  } catch(e) {
      console.log("e:", e);
  }
}

export function* downloadPOTemplate(action) {
  try {
    const resData = yield call(axiosT1.get, DOWNLOAD_PO_TEMPLATE_URL);
    const response = resData.data
    const presignedUrlData = yield call(getPresignedUrl, {
      response,
    });
    if(presignedUrlData && presignedUrlData.url) {
      downloadUrl(presignedUrlData.url);
    }
  } catch(e) {
      console.log("e:", e); 
      if(e.response && e.response.data) {
        yield put({
          type: TOAST_ERROR,
          message: (e.response.data || {}).message
        });
      }
  }
}

export function* uploadPODetails(action) {
  try {
    const resData = yield call(axiosT1.post, UPLOAD_PO_URL, action.payload);
    if(action.onSuccess) {
      action.onSuccess();
    }
    yield put({
      type: TOAST_SUCCESS,
      message: (resData.data || {}).message
  });
  } catch(e) {
      console.log("e:", e);
      if(e.response && e.response.data) {
        yield put({
          type: TOAST_ERROR,
          message: (e.response.data || {}).message
        });
      }
  }
}

export function* getRawMaterialsOrProductionStatus(action) {
  try {
    const resData = yield call(axiosT1.get, GET_RAW_MATERIALS_OR_PRODUCTION_STATUS_URL, {params: action.payload});
    if(action.onSuccess) {
      action.onSuccess(resData.data && resData.data.data && resData.data.data.list || []);
    }
  } catch(e) {
      console.log("e:", e);
      if(e.response && e.response.data) {
        yield put({
          type: TOAST_ERROR,
          message: (e.response.data || {}).message
        });
      }
  }
}

export function* saveRawMaterialsOrProductionStatus(action) {
  try {
    const resData = yield call(axiosT1.post, SAVE_RAW_MATERIALS_OR_PRODUCTION_STATUS_URL, action.data);
    if(action.onSuccess) {
      action.onSuccess();
    }
    yield put({
      type: TOAST_SUCCESS,
      message: (resData.data || {}).message
    });
  } catch(e) {
      console.log("e:", e);
      if(e.response && e.response.data) {
        yield put({
          type: TOAST_ERROR,
          message: (e.response.data || {}).message
        });
      }
  }
}

export function* updateRawMaterialsOrProductionStatus(action) {
  try {
    const resData = yield call(axiosT1.put, UPDATE_RAW_MATERIALS_OR_PRODUCTION_STATUS_URL, action.data);
    if(action.onSuccess) {
      action.onSuccess();
    }
    yield put({
      type: TOAST_SUCCESS,
      message: (resData.data || {}).message
    });
  } catch(e) {
      console.log("e:", e);
      if(e.response && e.response.data) {
        yield put({
          type: TOAST_ERROR,
          message: (e.response.data || {}).message
        });
      }
  }
}

export function* acceptOrRejectRawMaterialsOrProductionStatus(action) {
  try {
    const resData = yield call(axiosT1.put, ACCET_REJECT_RAW_MATERIALS_OR_PRODUCTION_STATUS_URL, action.data);
    if(action.onSuccess) {
      action.onSuccess();
    }
    yield put({
      type: TOAST_SUCCESS,
      message: (resData.data || {}).message
    });
  } catch(e) {
      console.log("e:", e);
      if(e.response && e.response.data) {
        yield put({
          type: TOAST_ERROR,
          message: (e.response.data || {}).message
        });
      }
  }
}

export function* getPODataById(action) {
  try {
    const resData = yield call(axiosT1.get, GET_PO_DATA_BY_ID_URL, {params: action.payload});
    if(action.onSuccess) {
      action.onSuccess(resData.data && resData.data.data || {});
    }
  } catch(e) {
      console.log("e:", e);
      if(e.response && e.response.data) {
        yield put({
          type: TOAST_ERROR,
          message: (e.response.data || {}).message
        });
      }
  }
}

export function* cancelPO(action) {
  try {
    const resData = yield call(axiosT1.put, CANCEL_PO_URL, action.data);
    if(action.onSuccess) {
      action.onSuccess();
    }
    yield put({
      type: TOAST_SUCCESS,
      message: (resData.data || {}).message
    });
  } catch(e) {
      console.log("e:", e);
      if(e.response && e.response.data) {
        yield put({
          type: TOAST_ERROR,
          message: (e.response.data || {}).message
        });
      }
  }
}

export function* updatePO(action) {
  try {
    const resData = yield call(axiosT1.put, UPDATE_PO_URL, action.data);
    if(action.onSuccess) {
      action.onSuccess();
    }
    yield put({
      type: TOAST_SUCCESS,
      message: (resData.data || {}).message
    });
  } catch(e) {
      console.log("e:", e);
      if(e.response && e.response.data) {
        yield put({
          type: TOAST_ERROR,
          message: (e.response.data || {}).message
        });
      }
  }
}

export function* getPOHistory(action) {
  try {
    const resData = yield call(axiosT1.get, GET_PO_HISTORY_URL, {params: action.data});
    if(action.onSuccess) {
      action.onSuccess(resData.data && resData.data.data && resData.data.data.list || []);
    }
  } catch(e) {
      console.log("e:", e);
      if(e.response && e.response.data) {
        yield put({
          type: TOAST_ERROR,
          message: (e.response.data || {}).message
        });
      }
  }
}

export function* getPOStatusCount(action) {
  try {
    const resData = yield call(axiosT1.get, GET_PO_STATUS_COUNT_URL, {params: action.queryParams});
    if(action.onSuccess) {
      action.onSuccess(resData.data && resData.data.data && resData.data.data || {});
    }
  } catch(e) {
    console.log("e:", e);
    if(e.response && e.response.data) {
      yield put({
        type: TOAST_ERROR,
        message: (e.response.data || {}).message
      });
    }
  }
}

export function* getPOList(action) {
  try {
    const resData = yield call(axiosT1.get, GET_PO_LIST_URL);
    if(action.onSuccess) {
      action.onSuccess(resData.data && resData.data.data && resData.data.data || []);
    }
  } catch(e) {
    console.log("e:", e);
    if(e.response && e.response.data) {
      yield put({
        type: TOAST_ERROR,
        message: (e.response.data || {}).message
      });
    }
  }
}



export function* deleteRawMaterialsOrProductionStatus(action) {
  try {
    const resData = yield call(axiosT1.delete, DELETE_RAW_MATERIALS_OR_PRODUCTION_STATUS_URL,{ data: action.data } );
    if(action.onSuccess) {
      action.onSuccess();
    }
    yield put({
      type: TOAST_SUCCESS,
      message: (resData.data || {}).message
    });
  } catch(e) {
      console.log("e:", e);
      if(e.response && e.response.data) {
        yield put({
          type: TOAST_ERROR,
          message: (e.response.data || {}).message
        });
      }
  }
}


export function* poDetailsSaga() {
  yield takeLatest(GET_ALL_PO, getAllPO);
  yield takeLatest(CREATE_PO, createPO);
  yield takeLatest(GET_PO_DROPDOWN_LISTS, getPODropDownLists),
  yield takeLatest(GET_PART_DETAILS, getPartDetails),
  yield takeLatest(DOWNLOAD_PO_TEMPLATE, downloadPOTemplate),
  yield takeLatest(UPLOAD_PO_DETAILS, uploadPODetails),
  yield takeLatest(GET_RAW_MATERIALS_OR_PRODUCTION_STATUS, getRawMaterialsOrProductionStatus),
  yield takeLatest(SAVE_RAW_MATERIALS_OR_PRODUCTION_STATUS, saveRawMaterialsOrProductionStatus),
  yield takeLatest(UPDATE_RAW_MATERIALS_OR_PRODUCTION_STATUS, updateRawMaterialsOrProductionStatus),
  yield takeLatest(ACCEPT_REJECT_RAW_MATERIALS_OR_PRODUCTION_STATUS, acceptOrRejectRawMaterialsOrProductionStatus),
  yield takeLatest(GET_PO_DATA_BY_ID, getPODataById),
  yield takeLatest(CANCEL_PO, cancelPO),
  yield takeLatest(UPDATE_PO, updatePO),
  yield takeLatest(GET_PO_HISTORY, getPOHistory),
  yield takeLatest(GET_PO_STATUS_COUNT, getPOStatusCount),
  yield takeLatest(GET_PO_LIST, getPOList)
  yield takeLatest(DELETE_RAW_MATERIALS_OR_PRODUCTION_STATUS, deleteRawMaterialsOrProductionStatus)
}
